export class HtmlEditorColor {
  constructor(
    public readonly title: string,
    public readonly buttonText: string,
    public readonly colorCode: string,
  ) {}
}
